<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          <feather-icon
            icon="FilterIcon"
            svgClasses="text-primary"
          ></feather-icon
          >فیلترها
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full ml-5">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-2/12 flex-inline">
                <span>فیلتر:</span>
              </div>
              <div class="vx-col sm:w-8/12 flex-inline">
                <vs-input
                  v-model="filter"
                  class="w-full"
                  @keyup.enter="
                    pageNo = 1;
                    getData();
                  "
                />
              </div>
            </div>
          </div>
          <div class="vx-col w-full ml-5">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-2/12 flex-inline">
                <span>درگاه:</span>
              </div>
              <div class="vx-col sm:w-8/12 flex-inline">
                <!-- <vs-input v-model="filters.paymentType" class="w-full" /> -->
                <v-select
                  class="selectExample w-full"
                  v-model="merchantTypeFilter"
                  :options="merchantTypeList"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="vx-col w-full ml-5">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-2/12 flex-inline">
                <span>وضعیت:</span>
              </div>
              <div class="vx-col sm:w-8/12 flex-inline">
                <!-- <vs-input v-model="filters.paymentType" class="w-full" /> -->
                <v-select
                  class="selectExample w-full"
                  v-model="statusFilter"
                  :options="merchantStatus"
                ></v-select>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col">
            <vs-button @click="clear" class="mx-3" color="primary" type="border"
              >پاک کردن</vs-button
            >
          </div>
          <div class="vx-col">
            <vs-button
              @click="
                pageNo = 1;
                getData();
              "
              class="mx-3"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
              >جستجو</vs-button
            >
          </div>
          <div class="vx-col">
            <export-excel
              :data="merchantsExcel"
              :exportFields="json_fields"
              worksheet="Merchants"
              name="merchants.xls"
              :before-generate="getDataExcel"
            >
              <vs-button
                class="mx-0"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-download"
                >دانلود</vs-button
              >
            </export-excel>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <vx-card class="mb-2">
      <vs-table
        id="tbl2"
        ref="tbl2"
        :data="merchants"
        class="table-dark-inverted"
        @selected="selected"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="
                          p-3
                          border border-solid
                          d-theme-border-grey-light
                          rounded-full
                          d-theme-dark-bg
                          cursor-pointer
                          flex
                          items-center
                          justify-between
                          font-medium
                        "
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th>شماره همراه</vs-th>
          <vs-th>نام</vs-th>
          <vs-th>نام خانوادگی</vs-th>
          <vs-th>فروشگاه</vs-th>
          <vs-th>کد پذیرندگی</vs-th>
          <vs-th sort-key="state" key="state">وضعیت</vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="tr.shopId" v-for="(tr, indextr) in data">
            <!-- <vs-td>
              <feather-icon
                :title="PaymentType[tr.transaction.paymentType].title"
                :icon="PaymentType[tr.transaction.paymentType].icon"
                svgClasses="h-6 w-6"
              ></feather-icon>
              <span>{{PaymentType[tr.transaction.paymentType].title}}</span>
            </vs-td>-->
            <vs-td class="mx-0 pr-0">
              <feather-icon
                :title="MerchantType[tr.merchantType].title"
                :icon="MerchantType[tr.merchantType].icon"
                :svgClasses="[`h-6 w-6 stroke-current `]"
              ></feather-icon>
            </vs-td>
            <vs-td class="mx-0 px-2">
              <span>{{ tr.userName }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.firstName }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.lastName }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.merchant.shopName }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.merchant.acceptorCode }}</span>
            </vs-td>
            <!-- <vs-td>
              <span>{{tr.commissionGroup?tr.commissionGroup.name:''}}</span>
            </vs-td>-->
            <!-- <vs-td>
              <feather-icon
                :title="MerchantStatus[tr.merchant.status].title"
                :icon="MerchantStatus[tr.merchant.status].icon"
                :svgClasses="[`h-6 w-6 stroke-current text-${MerchantStatus[tr.merchant.status].color}`]"
              ></feather-icon>
            </vs-td>-->
            <vs-td
              class="pl-0 pr-0"
              v-if="MerchantStatus[tr.merchant.status]"
              :title="
                MerchantStatus[tr.merchant.status].title +
                '\n' +
                MerchantStatus[tr.merchant.status].description
              "
            >
              <vs-chip
                :color="MerchantStatus[tr.merchant.status].color"
                class="product-order-status"
                >{{ MerchantStatus[tr.merchant.status].minTitle }}</vs-chip
              >
            </vs-td>
            <vs-td v-else> </vs-td>
            <vs-td class="px-2">
              <a @click="showDetails(tr.shopId, tr.merchant.shopName)"
                >جزئیات</a
              >
            </vs-td>
            <vs-td class="px-2">
              <a
                @click="
                  showTransaction(tr.userId, tr.accountId, tr.merchant.shopName)
                "
                >تراکنشها</a
              >
            </vs-td>
            <vs-td class="px-2">
              <a
                @click="
                  showSettlements(tr.userId, tr.accountId, tr.merchant.shopName)
                "
                >تسویه‌ها</a
              >
            </vs-td>
            <vs-td class="px-2">
              <a @click="showBills(tr.accountId, tr.merchant.shopName)"
                >قبضها</a
              >
            </vs-td>
            <vs-td class="px-2">
              <vs-dropdown>
                <a class="flex items-center" href.prevent>
                  عملیات
                  <i class="material-icons">expand_more</i>
                </a>
                <vs-dropdown-menu>
                  <!--deactivation for Active -->
                  <vs-dropdown-item
                    @click="
                      showGateways(
                        tr.merchant.id,
                        tr.firstName + ' ' + tr.lastName
                      )
                    "
                    >درگاه ها</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    @click="
                      selectCommissionGroup(tr.shopId, tr.merchant.shopName)
                    "
                    >قالب کارمزد</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    @click="
                      selectCustomSettingGroup(tr.shopId, tr.merchant.shopName)
                    "
                    >قالب تنظیمات</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="[1].includes(tr.merchant.status)"
                    @click="editStatus(tr, -10)"
                    >غیرفعال</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="[1].includes(tr.merchant.status)"
                    @click="
                      showGenerateTestBill(tr.shopId, tr.merchant.shopName)
                    "
                    >قبض آزمایشی</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="[1].includes(tr.merchant.status)"
                    @click="
                      confirmSendActivatedSms(tr.shopId, tr.merchant.shopName)
                    "
                    >ارسال پیامک فعالسازی</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="[1].includes(tr.merchant.status)"
                    @click="
                      buildEditIbanRequest(tr.shopId, tr.merchant.shopName)
                    "
                    >درخواست ویرایش شبا</vs-dropdown-item
                  >
                  <vs-dropdown-item @click="buildCreateDeactivationRequest(tr.shopId)"
                    >درخواست غیر فعال سازی</vs-dropdown-item
                  >
                  <vs-dropdown-item  @click="activeDeactive(tr.shopId,false)"
                    >{{true ? ' غیر فعال سازی' : ' فعال سازی'}}</vs-dropdown-item
                  >

                  <!--activation for Deactive -->
                  <vs-dropdown-item
                    v-if="[-10].includes(tr.merchant.status)"
                    @click="editStatus(tr, 1)"
                    >فعال</vs-dropdown-item
                  >

                  <!--deactiveRequest for Active -->
                  <vs-dropdown-item
                    :disabled="true"
                    v-if="[1].includes(tr.merchant.status)"
                    @click="editStatus(tr, -12)"
                    >ارسال درخواست غیرفعال کردن به شاپرک</vs-dropdown-item
                  >

                  <!--activeRequest for ComplateFile,DeactiveTemporarilyProviderRequested,DeactiveTemporarilyCustomerRequested -->
                  <vs-dropdown-item
                    v-if="[-11, -12].includes(tr.merchant.status)"
                    @click="editStatus(tr, 1)"
                    >ارسال درخواست فعال کردن به شاپرک</vs-dropdown-item
                  >

                  <!--collectRequest for Active -->
                  <vs-dropdown-item
                    :disabled="true"
                    v-if="[1, -11, -12, -13].includes(tr.merchant.status)"
                    @click="editStatus(tr, -15)"
                    >ارسال درخواست جمع‌آوری به شاپرک</vs-dropdown-item
                  >
                  <vs-dropdown-item @click="showGenerateApiKey(tr)">
                    دریافت کد وبسرویس
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-if="tr.merchantType == 0"
                    @click="showAsignPromoter(tr.userId, tr.merchant.shopName)"
                    >تعیین بازاریاب</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="
          () => {
            getData();
          }
        "
      />
    </vx-card>

    <view-merchant ref="ViewMerchant1"></view-merchant>

    <generate-api-key ref="GenerateApiKey1" />
    <generate-test-bill ref="GenerateTestBill1" />
    <select-commission-group
      ref="SelectCommissionGroup"
    ></select-commission-group>
    <select-custom-setting-group
      ref="SelectCustomSettingGroup"
    ></select-custom-setting-group>
    <management-ibans ref="ManagementIbans1" />
    <select-promoter
      ref="SelectPromoter1"
      @assign="assignPromoter"
      @unassign="unassignPromoter"
    />
  </div>
</template>
<style lang="scss">
.nav-transacttions > .vs-popup {
  width: 100%;
}
</style>
<script>
import GenerateApiKey from "./GenerateApiKey";
import vSelect from "vue-select";
import { MerchantStatus, MerchantType } from "@/enums.js";
import ViewMerchant from "./ViewMerchant.vue";
import GenerateTestBill from "./GenerateTestBill.vue";
import SelectCommissionGroup from "./SelectCommissionGroup.vue";
import SelectCustomSettingGroup from "./SelectCustomSettingGroup.vue";
import ManagementIbans from "../draft/ManagementIbans.vue";
import SelectPromoter from "../promoter/SelectPromoter.vue";
import Vue from "vue";

export default {
  props: {
    transactions: {},
  },
  components: {
    "v-select": vSelect,
    ViewMerchant,
    GenerateTestBill,
    SelectCommissionGroup,
    SelectCustomSettingGroup,
    GenerateApiKey,
    ManagementIbans,
    "select-promoter": SelectPromoter,
  },
  data() {
    return {
      merchants: [],
      merchantsExcel: [],
      MerchantStatus,
      MerchantType,
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      statusFilter: "",
      merchantTypeFilter: null,
      filter: "",
      editingRecord: undefined,
      selectedUserId: null,
      selectedShopName: "",
      json_fields: {
        moblie: "userName",
        firstname: "firstName",
        lastname: "lastName",
        shopname: "merchant.shopName",
        gateway: {
          field: "merchantType",
          callback: (value) => {
            return value ? "اینترنتی" : "پیامکی";
          },
        },
      },
    };
  },
  computed: {
    merchantStatus: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.MerchantStatus)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
    merchantTypeList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.MerchantType)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
  },
  methods: {
    async getDataExcel() {
      await this.getData(true);
    },
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filter = this.$route.query.f || this.filter;
        this.statusFilter = this.$route.query.sf
          ? this.merchantStatus.find((x) => x.value == this.$route.query.sf)
          : null;
        this.merchantTypeFilter = this.$route.query.mt
          ? this.merchantTypeList.find((x) => x.value == this.$route.query.mt)
          : null;
      }
    },
    async getData(download = false) {
      const query = {
        ps: this.pageSize,
        pno: this.pageNo,
      };
      if (this.filter) query.f = this.filter;
      if (this.statusFilter) query.sf = this.statusFilter.value;
      if (this.merchantTypeFilter) query.mt = this.merchantTypeFilter.value;
      this.$router.replace({
        query: query,
      });
      let payload = {
        params: {
          MaxResultCount: download ? 2000 : this.pageSize,
          SkipCount: download ? 0 : this.pageSize * (this.pageNo - 1),
          Filter: this.filter,
          StatusFilter:
            this.statusFilter == null ? null : this.statusFilter.value,
          merchantTypeFilter:
            this.merchantTypeFilter == null
              ? null
              : this.merchantTypeFilter.value,
        },
      };
      let loading = this.$vs.loading();
      await this.$http
        .get("/api/services/app/Merchants/GetAll", payload)
        .then((response) => {
          if (download) {
            this.merchantsExcel = response.data.result.items;
            if (response.data.result.totalCount > 2000)
              this.$vs.notify({
                time: 5000,
                color: "danger",
                title: "خطا!",
                text: `خروجی درخواست شما شامل ${response.data.result.totalCount} رکورد است.
                      <br/>
              خروجی اکسل تنها شامل 2000 رکورد ابتدایی می‌باشد.`,
              });
          } else {
            this.merchants = response.data.result.items;
            this.totalCount = response.data.result.totalCount;
            this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http

      // this.$http
      //   .get("api/services/app/Transactions/GetAll", payload)
      //   .then(response => {
      //     this.merchants = response.data.result.data.items;
      //   }) //end success
      //   .catch(error => {
      //     console.log(error);
      //   }); //end http
    },
    clear() {
      this.statusFilter = "";
      this.merchantTypeFilter = null;
      this.filter = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    editStatus() {},
    showTransaction(userId, accountId, shopName) {
      this.$router.push({
        name: "MerchantTransactions",
        query: {
          t: shopName,
          did: userId,
          a: accountId,
        },
      });
    },
    showSettlements(userId, accountId, shopName) {
      this.$router.push({
        name: "Settlements",
        query: {
          shopName: shopName,
          userId: userId,
          aid: accountId,
        },
      });
    },
    showBills(accountId, shopName) {
      this.$router.push({
        name: "bills",
        query: {
          shopName: shopName,
          aid: accountId,
        },
      });
    },
    confirmSendActivatedSms(id, shopName) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `تاییدیه ارسال پیامک`,
        text: `آیا از ارسال پیامک فعالسازی به "${shopName}" مطمئن هستید؟`,
        accept: () => {
          this.sendActivatedSms(id);
        },
        acceptText: "تایید",
        cancelText: "انصراف",
      });
    },
    sendActivatedSms(id) {
      let loading = this.$vs.loading();

      let payload = {
        params: {},
      };
      this.$http
        .post(
          `/api/services/app/Merchants/NotifyFinilizedMerchant?shopId=${id}`
        )
        .then((response) => {
          if (response.data.result)
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پیام با موفقیت ارسال شد",
            });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    buildCreateDeactivationRequest(id) {
      let loading = this.$vs.loading();
      let payload = {
        id: id,
        isActive: false,
      };
      this.$http
        .post(`/api/services/app/Shaparak/CreateActivationDraftRequest`,payload)
        .then((response) => {
          if (response.data.result)
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "درخواست با موفقیت ثبت شد",
            });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    activeDeactive(id,state) {
      let loading = this.$vs.loading();
      let payload = {
        shopId: id,
        state:state
      };
      this.$http
        .post(`/api/services/app/Accounts/SetAccountActiveStatus`,payload)
        .then((response) => {
          if (response.data.success)
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "با موفقیت غیر فعال شد",
            });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    showGenerateTestBill(shopId, shopName) {
      this.$refs.GenerateTestBill1.show(shopId, shopName);
    },
    selectCommissionGroup(shopId, shopName) {
      this.$refs.SelectCommissionGroup.show(shopId, shopName);
    },
    showGateways(merchantId, fullName) {
      this.$router.push({
        path: "/merchant/gateways",
        query: {
          fullName: fullName,
          mid: merchantId,
        },
      });
    },
    selectCustomSettingGroup(shopId, shopName) {
      this.$refs.SelectCustomSettingGroup.show(shopId, shopName);
    },
    showGenerateApiKey(tr) {
      this.$refs.GenerateApiKey1.show(tr.shopId, tr.merchant.shopName, false);
    },
    buildEditIbanRequest(merchantId, shopName) {
      this.$refs.ManagementIbans1.show(merchantId, shopName);
    },
    showAsignPromoter(userId, shopName) {
      this.selectedUserId = userId;
      this.$refs.SelectPromoter1.show(userId, null, shopName);
    },
    assignPromoter(userId) {
      let loading = this.$vs.loading();

      let payload = {
        promoterUserId: userId,
        MerchantUserId: this.selectedUserId,
      };
      this.$http
        .post(`/api/services/app/Promoters/AsignMerchant`, payload)
        .then((response) => {
          if (response.data.success)
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده با موفقیت به بازاریاب الصاق شد",
            });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    unassignPromoter(userId) {
      let loading = this.$vs.loading();

      let payload = {
        id: this.selectedUserId,
      };
      this.$http
        .post(`/api/services/app/Promoters/UnasignMerchant`, payload)
        .then((response) => {
          if (response.data.success)
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده از بازاریاب جدا شد",
            });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    showDetails(id, shopName) {
      this.$refs.ViewMerchant1.show(id, shopName);
    },
    selected(tr) {
      //this.showTransaction(tr.transaction.id);
    },
  },
  mounted() {
    this.initFilters();
    this.getData();
    // this.$refs.tbl2.$on('selected', selected => {
    //         console.log(selected);
    //       });
  },
};
</script>
